module.exports = __webpack_public_path__ + "static/img/eric.24fd684.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success-stories/eric.jpeg
// module id = Wt2S
// module chunks = 0